export default "__VITE_ASSET__d59e9efd__"